import {
    COLUMN_CERTIFICATE_AUTHORITY,
    COLUMN_CERTIFICATE_STATUS,
    COLUMN_CREATED_BY,
    COLUMN_EXPIRY_DATE,
    COLUMN_LAST_MODIFIED_BY,
    COLUMN_NAME,
    COLUMN_TYPE,
    COLUMN_SITE,
    COLUMN_REVOKE
} from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";
import { FILTER_SITES } from "../../constants/filter-types";

const CertificatesColumns: TableColumn[] = [
    {
        id: 0,
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        sortByName: "name",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        id: 1,
        heading: "Type",
        accessor: "certType",
        isNumeric: false,
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        id: 2,
        heading: "Created By",
        accessor: "createdBy",
        isNumeric: false,
        active: true,
        translationKey: "createdBy",
        columnId: COLUMN_CREATED_BY,
    },
    {
        id: 3,
        heading: "Last Modified By",
        accessor: "lastModifiedBy",
        isNumeric: false,
        active: true,
        translationKey: "lastModifiedBy",
        columnId: COLUMN_LAST_MODIFIED_BY,
    },
    {
        id: 4,
        heading: "Expiry Date",
        accessor: "expiryDate",
        isNumeric: false,
        sortByName: "certExpirationDateUtc",
        sortDirection: "asc",
        active: true,
        translationKey: "expiryDate",
        columnId: COLUMN_EXPIRY_DATE,
    },
    {
        id: 5,
        heading: "Certificate Authority",
        accessor: "certificateAuthority",
        isNumeric: false,
        active: true,
        translationKey: "certificateAuthority",
        columnId: COLUMN_CERTIFICATE_AUTHORITY,
    },
    {
        id: 6,
        heading: "Status",
        accessor: "certStatus",
        isNumeric: false,
        active: true,
        translationKey: "status",
        columnId: COLUMN_CERTIFICATE_STATUS,
    },
    {
        id: 7,
        heading: "Site",
        accessor: "site",
        active: true,
        isNumeric: false,
        translationKey: "site",
        filterId: FILTER_SITES,
        searchOnName: "site.id",
        sortByName: "site.siteName",
        lookupName: "site.siteName",
        sortDirection: "asc",
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    }
];

export default CertificatesColumns;
